import { Box, paletteColors } from '@evaneos/b2b-ui';
import { Outlet } from 'react-router-dom';

import { buildGoogleOAuthUrl } from '../../resources/appointment/operations';
import { useGetCalendarStatus } from '../../resources/appointment/queries';
import { useConnectCalendarMutation } from '../../resources/appointment/mutations';

import { AppointmentDisconnectedState } from './partials/AppointmentDisconnectedState';
import { AppointmentTabs } from './components/AppointmentTabs';

export const AppointmentLayout = (): JSX.Element | null => {
    const { data: calendarStatus, isLoading } = useGetCalendarStatus();
    const { mutate: connectCalendar } = useConnectCalendarMutation();
    const isConnected = calendarStatus?.google === 'connected';

    const handleConnect = () => {
        // TODO : remove when feature is done
        if (import.meta.env.MODE === 'standalone') {
            connectCalendar({
                provider: 'google',
                authorizationCode: 'fake-code',
                redirectUri: '',
            });
        } else {
            window.location.assign(buildGoogleOAuthUrl());
        }
    };

    if (isLoading) return null;

    return (
        <Box
            data-spec-id="agenda-page"
            sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}
        >
            <AppointmentTabs isConnected={isConnected} />

            <Box sx={{ flex: 1, bgcolor: paletteColors.neutral[100], overflow: 'auto' }}>
                {!isConnected ? (
                    <AppointmentDisconnectedState onConnect={handleConnect} />
                ) : (
                    <Outlet />
                )}
            </Box>
        </Box>
    );
};
